<script lang="ts">
    import {onMount} from 'svelte';
    import type {AxiosInstance} from 'axios';
    import {modal} from 'general/store';
    import {getEmailFromLocalStorage} from 'general/libs/getEmailFromLocalStorage';
    import {getQrCode} from 'desktop/components/qrcode/helpers';
    import {getRefId} from 'general/libs/getRefId';

    import s from './style.module.css';

    export let instance: AxiosInstance;
    export let size = 150;
    export let text: string;
    export let marginTop = '';
    export let marginBottom = '';

    let qrImage;

    onMount(async () => {
        const email = $modal.email || getEmailFromLocalStorage() || '';
        if (email) {
            const refId = $modal.refId || (await getRefId(instance, email));
            qrImage = await getQrCode(instance, {refId, width: size, text});
        }
    });
</script>

<div
    class={s.wrapper}
    style="
    margin-top: {marginTop};
    margin-bottom: {marginBottom};
    height: {size}px;
    width: {size}px;
"
>
    {#if qrImage}
        <img src={qrImage} alt="SMS QR code" width={size} height={size} />
    {/if}
</div>
